import {
  type FetchCurrentUserResponse,
  type LoginResponse,
  UndecoratedUser,
  USER_ROLE_ID,
  type UserRoleId,
  type ValidateLoginResponse,
} from '@flemingmetrics/api-client';

const ADMIN_ROLES: UserRoleId[] = [USER_ROLE_ID.ADMIN, USER_ROLE_ID.SUPERADMIN];

export function isAdmin(user?: UndecoratedUser | null) {
  if (!user?.userRoleId) return false;
  return ADMIN_ROLES.includes(user.userRoleId as UserRoleId);
}

export function isValidatedResponse(
  response: FetchCurrentUserResponse
): response is ValidateLoginResponse {
  return !isLoginResponse(response);
}

function isLoginResponse(
  response: FetchCurrentUserResponse
): response is LoginResponse {
  return (
    'status' in response && 'strategy' in response && 'message' in response
  );
}
